/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { Check1 } from "../../icons/Check1";
import "./style.css";

export const CmpWorkoutcard = ({
  state,
  text = "Week 2 • Day 3",
  text1 = "Week 2 • Day 2",
  text2 = "Week 2 • Day 1",
  text3 = "1 km Easy Run",
}) => {
  return (
    <div className="cmp-workoutcard">
      <div className="week-day">
        {state === "ack" && <p className="p">{text1}</p>}

        {state === "done" && <p className="p">{text}</p>}

        {state === "live" && <p className="p">{text2}</p>}
      </div>

      <div className={`element-km-easy-run ${state}`}>
        {state === "live" && <>{text3}</>}

        {state === "ack" && <>Volleyball</>}

        {state === "done" && <>Long walk</>}
      </div>

      {["ack", "done"].includes(state) && (
        <div className="badge-wrapper">
          <div className="badge">
            <Check1 className="check" />
          </div>
        </div>
      )}
    </div>
  );
};

CmpWorkoutcard.propTypes = {
  state: PropTypes.oneOf(["live", "ack", "done"]),
  text: PropTypes.string,
  text1: PropTypes.string,
  text2: PropTypes.string,
  text3: PropTypes.string,
};
